"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Address = _interopRequireDefault(require("./Address"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The DirectDebitDetails model module.
 * @module model/DirectDebitDetails
 * @version 3.0
 */
var DirectDebitDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>DirectDebitDetails</code>.
   * @alias module:model/DirectDebitDetails
   */
  function DirectDebitDetails() {
    _classCallCheck(this, DirectDebitDetails);
    DirectDebitDetails.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(DirectDebitDetails, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>DirectDebitDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DirectDebitDetails} obj Optional instance to populate.
     * @return {module:model/DirectDebitDetails} The populated <code>DirectDebitDetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new DirectDebitDetails();
        if (data.hasOwnProperty('bankName')) {
          obj['bankName'] = _ApiClient["default"].convertToType(data['bankName'], 'String');
        }
        if (data.hasOwnProperty('bankAddress')) {
          obj['bankAddress'] = _Address["default"].constructFromObject(data['bankAddress']);
        }
        if (data.hasOwnProperty('bankAccountNumber')) {
          obj['bankAccountNumber'] = _ApiClient["default"].convertToType(data['bankAccountNumber'], 'String');
        }
        if (data.hasOwnProperty('branchSortCode')) {
          obj['branchSortCode'] = _ApiClient["default"].convertToType(data['branchSortCode'], 'String');
        }
        if (data.hasOwnProperty('nameOnAccount')) {
          obj['nameOnAccount'] = _ApiClient["default"].convertToType(data['nameOnAccount'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DirectDebitDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DirectDebitDetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['bankName'] && !(typeof data['bankName'] === 'string' || data['bankName'] instanceof String)) {
        throw new Error("Expected the field `bankName` to be a primitive type in the JSON string but got " + data['bankName']);
      }
      // validate the optional field `bankAddress`
      if (data['bankAddress']) {
        // data not null
        _Address["default"].validateJSON(data['bankAddress']);
      }
      // ensure the json data is a string
      if (data['bankAccountNumber'] && !(typeof data['bankAccountNumber'] === 'string' || data['bankAccountNumber'] instanceof String)) {
        throw new Error("Expected the field `bankAccountNumber` to be a primitive type in the JSON string but got " + data['bankAccountNumber']);
      }
      // ensure the json data is a string
      if (data['branchSortCode'] && !(typeof data['branchSortCode'] === 'string' || data['branchSortCode'] instanceof String)) {
        throw new Error("Expected the field `branchSortCode` to be a primitive type in the JSON string but got " + data['branchSortCode']);
      }
      // ensure the json data is a string
      if (data['nameOnAccount'] && !(typeof data['nameOnAccount'] === 'string' || data['nameOnAccount'] instanceof String)) {
        throw new Error("Expected the field `nameOnAccount` to be a primitive type in the JSON string but got " + data['nameOnAccount']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} bankName
 */
DirectDebitDetails.prototype['bankName'] = undefined;

/**
 * @member {module:model/Address} bankAddress
 */
DirectDebitDetails.prototype['bankAddress'] = undefined;

/**
 * @member {String} bankAccountNumber
 */
DirectDebitDetails.prototype['bankAccountNumber'] = undefined;

/**
 * @member {String} branchSortCode
 */
DirectDebitDetails.prototype['branchSortCode'] = undefined;

/**
 * @member {String} nameOnAccount
 */
DirectDebitDetails.prototype['nameOnAccount'] = undefined;
var _default = exports["default"] = DirectDebitDetails;